export const trackSignUp = () => {
  if (window.gtag) window.gtag("event", "sign_up", { method: "email" });
  if (window.fbq) window.fbq("track", "CompleteRegistration");
};

export const trackPrediction = (params) => {
  if (window.gtag) window.gtag("event", "make_prediction", params);
  if (window.fbq) window.fbq("trackCustom", "MakePrediction", params);
};
